var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({attrs:{"no-data-text":"Danh sách trống","item-text":"title","items":_vm.classes,"item-value":"id","return-object":"","auto-select-first":"","loading":_vm.loading,"clearable":""},on:{"change":_vm.onChange,"input":function($event){return _vm.$emit('input', $event)}}},'v-autocomplete',this.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }